// RITA-1541: Zeitangabe in Sperrhinweisen. Ein Zeitpunkt (kein Kalendertag): am selben Tag nur die
// Uhrzeit („10:42 Uhr“), an einem anderen Tag mit Datum („17.10.2026, 16:05 Uhr“); beides in der
// Ortszeit des Browsers wie die übrigen Zeitangaben der Liste.
export default function formatiereSperrzeit(iso: string, jetzt: Date = new Date()): string {
  const zeit = new Date(iso);
  if (Number.isNaN(zeit.getTime())) return 'unbekannter Zeit';
  const uhr = `${zeit.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })} Uhr`;
  const gleicherTag =
    zeit.getFullYear() === jetzt.getFullYear() &&
    zeit.getMonth() === jetzt.getMonth() &&
    zeit.getDate() === jetzt.getDate();
  if (gleicherTag) return uhr;
  return `${zeit.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })}, ${uhr}`;
}
